import { ScrollToService } from '@nicky-lenaers/ngx-scroll-to';
import * as i0 from "@angular/core";
import * as i1 from "@nicky-lenaers/ngx-scroll-to";
var ScrollService = /** @class */ (function () {
    function ScrollService(_scrollToService) {
        this._scrollToService = _scrollToService;
    }
    ScrollService.prototype.triggerScrollTo = function (destination) {
        var config = {
            target: destination
        };
        this._scrollToService.scrollTo(config);
    };
    ScrollService.ngInjectableDef = i0.defineInjectable({ factory: function ScrollService_Factory() { return new ScrollService(i0.inject(i1.ScrollToService)); }, token: ScrollService, providedIn: "root" });
    return ScrollService;
}());
export { ScrollService };
